var _style, _desc, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkspaceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 54 54",
    style: {
      enableBackground: "new 0 0 54 54"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#Oval-Copy-2_1_);}\n\t.st1{fill:none;stroke:#262262;stroke-width:0.5213;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#262262;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "HOMEPAGE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage-v4",
    transform: "translate(-411.000000, -106.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(411.000000, 106.000000)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Oval-Copy-2_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -161.4323,
    y1: 175.2409,
    x2: -169.7589,
    y2: 175.2407,
    gradientTransform: "matrix(54 0 0 -54 9116 9490)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#73BCE2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5847,
    style: {
      stopColor: "#75C6A2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FDD883"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    className: "st0",
    cx: 27,
    cy: 27,
    r: 27
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(11.028169, 9.126761)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-1",
    className: "st1",
    points: "0.2,31.3 32.2,31.3 32.2,11.1 0.2,11.1  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    className: "st1",
    points: "1.5,10.3 1.5,6.3 30.1,6.3 30.1,10.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-4",
    className: "st1",
    points: "3,5.5 3,2.6 28.7,2.6 28.7,5.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-5",
    className: "st1",
    points: "4.3,1.9 4.3,0.1 27.4,0.1 27.4,1.9  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke-7",
    className: "st2",
    d: "M9.4,18c0,1,0.3,2.1,1.1,2.8c1,1,2.5,1.3,3.8,0.9l5.7,5.6c0.7,0.7,1.8,0.7,2.4,0 c0.7-0.7,0.7-1.8,0-2.4l-5.7-5.6c0.4-1.3,0.1-2.8-0.9-3.8c-1-1-2.5-1.3-3.9-0.9c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0,0.2,0.1,0.3 l1.8,1.8l-0.4,1.3L12,18.7l-1.8-1.8c-0.1-0.1-0.2-0.1-0.3-0.1c-0.1,0-0.2,0.1-0.2,0.2C9.5,17.4,9.4,17.7,9.4,18z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceIcon);
export default __webpack_public_path__ + "static/media/workspace-icon.17d47c8f504905c774226824e0caa181.svg";
export { ForwardRef as ReactComponent };